import { create } from "zustand";

import type { useTranslation } from "./useTranslation";

type ITranslationState = ReturnType<typeof useTranslation>;

interface ITState {
  translation: ITranslationState | null;
  setTranslation: (t: ITranslationState) => void;
}

export const useTranslationStore = create<ITState>((set) => ({
  translation: null,
  setTranslation: (translation: ITranslationState) => set(() => ({ translation })),
}));
